/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Vs_Yaml_Xml_S2_P1Inputs */

const en_guide_json_vs_yaml_xml_s2_p1 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S2_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON's strength lies in its simplicity and universal support. Every major programming language has built-in or standard library JSON support. It's the default format for REST APIs, making it the most common choice for web development.`)
};

const ko_guide_json_vs_yaml_xml_s2_p1 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S2_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON의 강점은 단순함과 범용적인 지원에 있습니다. 모든 주요 프로그래밍 언어에 내장 또는 표준 라이브러리 JSON 지원이 있습니다. REST API의 기본 포맷으로, 웹 개발에서 가장 일반적인 선택입니다.`)
};

const ja_guide_json_vs_yaml_xml_s2_p1 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_S2_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONの強みは、そのシンプルさと普遍的なサポートにあります。すべての主要なプログラミング言語には、組み込みまたは標準ライブラリのJSONサポートがあります。REST APIのデフォルトフォーマットであり、Web開発で最も一般的な選択肢です。`)
};

/**
* | output |
* | --- |
* | "JSON's strength lies in its simplicity and universal support. Every major programming language has built-in or standard library JSON support. It's the defaul..." |
*
* @param {Guide_Json_Vs_Yaml_Xml_S2_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_vs_yaml_xml_s2_p1 = /** @type {((inputs?: Guide_Json_Vs_Yaml_Xml_S2_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Vs_Yaml_Xml_S2_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_vs_yaml_xml_s2_p1(inputs)
	if (locale === "ko") return ko_guide_json_vs_yaml_xml_s2_p1(inputs)
	return ja_guide_json_vs_yaml_xml_s2_p1(inputs)
});